import { createContext } from 'react';

interface ITeamCustomerPageContext {
	onReload: () => void;
}
const TeamCustomerPageContext = createContext<ITeamCustomerPageContext>({ onReload: () => {} });
export default TeamCustomerPageContext;
